export enum MovementStatusEnum {
  NotBooked,
  Booked,
  InTransit,
  Delivered,
  Aborted
}
